import { axiosApiInstance } from "../axios";
import type { ExpenseMutationPayload, ExpenseRecord } from "../types/expenses";

const authConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
  },
});

export async function createManualExpense(
  payload: ExpenseMutationPayload | FormData,
): Promise<ExpenseRecord> {
  const response = await axiosApiInstance.post<ExpenseRecord>("expenses/manual-upload", payload, authConfig());

  return response.data;
}

export async function updateExpenseRecord(
  expenseId: number,
  payload: ExpenseMutationPayload,
): Promise<ExpenseRecord> {
  const response = await axiosApiInstance.patch<ExpenseRecord>(
    `expenses/update/${expenseId}`,
    payload,
    authConfig()
  );

  return response.data;
}
